import { MotionHighlightItem, MotionHighlightRoot } from "./parts";

const MotionHighlight = Object.assign(MotionHighlightRoot, {
  Item: MotionHighlightItem,
});

export default MotionHighlight;
